import { useAppDispatch, useAppSelector } from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { getPopup, markPopupAsViewed } from "./popup.thunk";
import { clearPopup } from "./popup.slice";
import { isIdle, isLoading, isSuccess, isError } from "@/app/utils/asyncStatus";

const usePopup = () => {
  const dispatch = useAppDispatch();
  const { data, status, error } = useAppSelector((store) => store.popup);

  const fetchPopup = useCallback(async () => {
    const res = await dispatch(getPopup());
    return res.meta.requestStatus === "fulfilled";
  }, [dispatch]);

  const markAsViewed = useCallback(
    async (popup_id: number) => {
      await dispatch(markPopupAsViewed(popup_id));
    },
    [dispatch],
  );

  const dismiss = useCallback(() => {
    dispatch(clearPopup());
  }, [dispatch]);

  return {
    popup: data,
    error,
    isIdle: isIdle(status),
    isLoading: isLoading(status),
    isSuccess: isSuccess(status),
    isError: isError(status),
    fetchPopup,
    markAsViewed,
    dismiss,
  };
};

export default usePopup;